/** Reasons reserved for automated ETA writes (System: CPT, System: Default, etc.). */
const RESERVED_SYSTEM_ETA_REASON_PREFIX = /^system\s*:/i;

export function isReservedSystemEtaReason(
  reason: string | null | undefined,
): boolean {
  if (!reason || typeof reason !== "string") {
    return false;
  }
  return RESERVED_SYSTEM_ETA_REASON_PREFIX.test(reason.trim());
}

export const RESERVED_SYSTEM_ETA_REASON_MESSAGE =
  'Reason cannot start with "System:" — that prefix is reserved for automated CPT updates.';
